<span class="ds-status-pill" [class]="'ds-status-pill is-' + tone">
  <ng-content></ng-content>
  @if (label) {
    {{ label }}
  }
</span>
